"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReorderSopTaskDataConfigMutation = exports.useDeleteSopTaskDataConfigMutation = exports.useUpdateSopTaskDataConfigMutation = exports.useAddSopTaskDataConfigMutation = exports.useDeleteSopTaskMutation = exports.useUpdateSopTaskMutation = exports.useCreateSopTaskMutation = exports.useRemoveAreaLibraryMutation = exports.useLinkAreaLibraryMutation = exports.useDeleteSopLibraryMutation = exports.useCreateSopLibraryMutation = exports.useUpdateSopLibraryMutation = exports.useGetSopLibrariesQuery = exports.useGetSopLibraryQuery = exports.sopLibraryApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
var client_scoped_query_1 = require("../../utils/client-scoped-query");
exports.sopLibraryApi = (0, react_1.createApi)({
    reducerPath: "sopLibraryApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.API_URL),
    tagTypes: ["sop-library"],
    endpoints: function (builder) { return ({
        getSopLibrary: builder.query({
            query: function (_a) {
                var id = _a.id;
                return "/v1/sop-library/".concat(id);
            },
            providesTags: ["sop-library"],
        }),
        getSopLibraries: builder.query({
            queryFn: (0, client_scoped_query_1.clientScopedQueryFn)("/v1/sop-library"),
            providesTags: ["sop-library"],
        }),
        updateSopLibrary: builder.mutation({
            query: function (_a) {
                var id = _a.id, name = _a.name;
                return ({ url: "/v1/sop-library/".concat(id), method: "PATCH", body: { name: name } });
            },
            invalidatesTags: ["sop-library"],
        }),
        createSopLibrary: builder.mutation({
            query: function (_a) {
                var clientId = _a.clientId, name = _a.name;
                return ({ url: "/v1/sop-library", method: "POST", body: { client_id: clientId, name: name } });
            },
            invalidatesTags: ["sop-library"],
        }),
        deleteSopLibrary: builder.mutation({
            query: function (_a) {
                var id = _a.id;
                return ({ url: "/v1/sop-library/".concat(id), method: "DELETE" });
            },
            invalidatesTags: ["sop-library"],
        }),
        linkAreaLibrary: builder.mutation({
            query: function (_a) {
                var id = _a.id, areaLibraryId = _a.areaLibraryId;
                return ({ url: "/v1/sop-library/".concat(id, "/areas"), method: "POST", body: { area_library_id: areaLibraryId } });
            },
            invalidatesTags: ["sop-library"],
        }),
        removeAreaLibrary: builder.mutation({
            query: function (_a) {
                var id = _a.id, areaLibraryId = _a.areaLibraryId;
                return ({ url: "/v1/sop-library/".concat(id, "/area-library/").concat(areaLibraryId), method: "DELETE" });
            },
            invalidatesTags: ["sop-library"],
        }),
        createSopTask: builder.mutation({
            query: function (_a) {
                var sopLibraryId = _a.sopLibraryId, body = __rest(_a, ["sopLibraryId"]);
                return ({ url: "/v1/sop-library/".concat(sopLibraryId, "/tasks"), method: "POST", body: body });
            },
            invalidatesTags: ["sop-library"],
        }),
        updateSopTask: builder.mutation({
            query: function (_a) {
                var sopLibraryId = _a.sopLibraryId, taskId = _a.taskId, body = __rest(_a, ["sopLibraryId", "taskId"]);
                return ({ url: "/v1/sop-library/".concat(sopLibraryId, "/tasks/").concat(taskId), method: "PATCH", body: body });
            },
            invalidatesTags: ["sop-library"],
        }),
        deleteSopTask: builder.mutation({
            query: function (_a) {
                var sopLibraryId = _a.sopLibraryId, taskId = _a.taskId;
                return ({ url: "/v1/sop-library/".concat(sopLibraryId, "/tasks/").concat(taskId), method: "DELETE" });
            },
            invalidatesTags: ["sop-library"],
        }),
        addSopTaskDataConfig: builder.mutation({
            query: function (_a) {
                var sopLibraryId = _a.sopLibraryId, taskId = _a.taskId, body = __rest(_a, ["sopLibraryId", "taskId"]);
                return ({
                    url: "/v1/sop-library/".concat(sopLibraryId, "/tasks/").concat(taskId, "/data-config"),
                    method: "POST",
                    body: body,
                });
            },
            invalidatesTags: ["sop-library"],
        }),
        updateSopTaskDataConfig: builder.mutation({
            query: function (_a) {
                var sopLibraryId = _a.sopLibraryId, taskId = _a.taskId, entryId = _a.entryId, body = __rest(_a, ["sopLibraryId", "taskId", "entryId"]);
                return ({
                    url: "/v1/sop-library/".concat(sopLibraryId, "/tasks/").concat(taskId, "/data-config/").concat(entryId),
                    method: "PATCH",
                    body: body,
                });
            },
            invalidatesTags: ["sop-library"],
        }),
        deleteSopTaskDataConfig: builder.mutation({
            query: function (_a) {
                var sopLibraryId = _a.sopLibraryId, taskId = _a.taskId, entryId = _a.entryId;
                return ({
                    url: "/v1/sop-library/".concat(sopLibraryId, "/tasks/").concat(taskId, "/data-config/").concat(entryId),
                    method: "DELETE",
                });
            },
            invalidatesTags: ["sop-library"],
        }),
        reorderSopTaskDataConfig: builder.mutation({
            query: function (_a) {
                var sopLibraryId = _a.sopLibraryId, taskId = _a.taskId, order = _a.order;
                return ({
                    url: "/v1/sop-library/".concat(sopLibraryId, "/tasks/").concat(taskId, "/data-config/reorder"),
                    method: "PATCH",
                    body: { order: order },
                });
            },
            invalidatesTags: ["sop-library"],
        }),
    }); },
});
exports.useGetSopLibraryQuery = exports.sopLibraryApi.useGetSopLibraryQuery, exports.useGetSopLibrariesQuery = exports.sopLibraryApi.useGetSopLibrariesQuery, exports.useUpdateSopLibraryMutation = exports.sopLibraryApi.useUpdateSopLibraryMutation, exports.useCreateSopLibraryMutation = exports.sopLibraryApi.useCreateSopLibraryMutation, exports.useDeleteSopLibraryMutation = exports.sopLibraryApi.useDeleteSopLibraryMutation, exports.useLinkAreaLibraryMutation = exports.sopLibraryApi.useLinkAreaLibraryMutation, exports.useRemoveAreaLibraryMutation = exports.sopLibraryApi.useRemoveAreaLibraryMutation, exports.useCreateSopTaskMutation = exports.sopLibraryApi.useCreateSopTaskMutation, exports.useUpdateSopTaskMutation = exports.sopLibraryApi.useUpdateSopTaskMutation, exports.useDeleteSopTaskMutation = exports.sopLibraryApi.useDeleteSopTaskMutation, exports.useAddSopTaskDataConfigMutation = exports.sopLibraryApi.useAddSopTaskDataConfigMutation, exports.useUpdateSopTaskDataConfigMutation = exports.sopLibraryApi.useUpdateSopTaskDataConfigMutation, exports.useDeleteSopTaskDataConfigMutation = exports.sopLibraryApi.useDeleteSopTaskDataConfigMutation, exports.useReorderSopTaskDataConfigMutation = exports.sopLibraryApi.useReorderSopTaskDataConfigMutation;
